module.exports = __webpack_public_path__ + "img/bb_g3_t_mouth-06.ccaf7220.svg";